import React from 'react';
import RtccBookingCancelTemplate from '../../components/template/RTCC/rtccBookingCancelTemplate';
import { confirmHotelReservation } from "../../const/RTCC";
import image_base from '../../resources/RTCC/image/img_home/rtcc_bg_000.jpg';
import common from "../../resources/RTCC/js/common/common";

class RtccBookingCancel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 予約確認モーダル
            reservationPopup: false,
            popupDataList: [],
            popupMessage: "",
            popupMode: "",
            popupTitle: "",
            // チェックイン・アウトモーダル
            calendarPopup: false,
            // チェックリストモーダル
            checkListPopup: false,
            beforeAreaId: "",
            beforeCountryId: "",
            // キャンセルモーダル
            rtccReservationCancelPopup: false
        };
    };
    render() {
        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (id, loginId) => {
            this.setState({ reservationPopup: !this.state.reservationPopup });
            common.doPost(confirmHotelReservation, { loginId: loginId }, afterConfirmHotelReservation);
            this.setState(
                {
                    popupMode: id,
                    popupTitle: "予約確認・変更"
                }
            );
        }
        // 予約情報取得後処理
        const afterConfirmHotelReservation = (res) => {
            const data = res.data;
            if (data.resultCode != 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.reserve,
                    }
                );
            }
        }
        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ reservationPopup: false }); };

        // チェックインモーダル 
        const onClickOpenCalendarWindow = (e) => {
            this.setState({ calendarPopup: !this.state.calendarPopup });
            let checkInFlg = false;
            let checkOutFlg = false;
            let title = "";
            if (e != undefined) {
                if (e.target.id == 'checkIn') {
                    checkInFlg = true;
                    checkOutFlg = false;
                    title = "搭乗日"
                }
                else if (e.target.id == 'checkOut') {
                    checkInFlg = false;
                    checkOutFlg = true;
                    title = "搭乗日"
                }
                this.setState(
                    {
                        checkInFlg: checkInFlg,
                        checkOutFlg: checkOutFlg,
                        popupTitle: title
                    }
                );
            }
        }

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ rtccReservationCancelPopup: true });
        }

        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => {
            this.setState({ rtccReservationCancelPopup: false });
        };

        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            },
        }

        return (
            <div style={style.base} >
                <RtccBookingCancelTemplate
                    state={this.state}
                    onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                />
            </div>
        )
    }
}
export default RtccBookingCancel;